import React from 'react'
import Image from 'next/image'
import Link from 'next/link'
import styled from '@emotion/styled'
import { gsColors as c } from '../../styles/Variables'
import { mq } from '../../helpers'

const CardWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 20px;
  background-color: ${c.khaki};
  border-top: 1px solid ${c.lightTangerine};
  padding: 32px;
  max-width: 750px;
  margin: 60px auto 0;

  ${mq('max', '800px')} {
    flex-direction: column;
    align-items: center;
    text-align: center;
    padding: 24px;
    margin: 40px 16px 0;
  }

  .card-headshot {
    width: 64px;
    height: 64px;
    border-radius: 50%;
    overflow: hidden;
    flex-shrink: 0;
    position: relative;

    img {
      object-fit: cover;
      object-position: center 0;
    }
  }

  .card-info {
    min-width: 0;
  }

  .card-name {
    font-family: Garnett;
    font-size: 24px;
    font-weight: 750;
    color: ${c.black};
    margin: 0;
    line-height: 140%;

    ${mq('max', '800px')} {
      font-size: 20px;
    }
  }

  .card-title {
    font-family: Euclid;
    font-size: 14px;
    color: ${c.darkGrey};
    margin: 4px 0 12px;
    line-height: 138%;
  }

  .card-bio {
    font-family: Euclid;
    font-size: 16px;
    color: ${c.black};
    line-height: 150%;
    margin: 0 0 16px;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;

    ${mq('max', '800px')} {
      font-size: 14px;
    }
  }

  .card-link {
    font-family: Euclid;
    font-size: 14px;
    font-weight: 600;
    color: ${c.sunsetOrange};
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
`

export default function AuthorCard({ author }) {
  if (!author) {
    return null
  }

  return (
    <CardWrapper>
      <div className="card-headshot">
        <Image
          src={author.headshot}
          alt={author.name}
          fill
        />
      </div>
      <div className="card-info">
        <h3 className="card-name">{author.name}</h3>
        <p className="card-title">{author.title}</p>
        <p className="card-bio">{author.shortBio}</p>
        <Link href={`/author/${author.slug}`} className="card-link">
          View Profile &rarr;
        </Link>
      </div>
    </CardWrapper>
  )
}
